import { ThemeConfig } from '../../core/helpers/theme-config';

export function getPagesCount(totalCount): number {
  return Math.ceil(totalCount / ThemeConfig.itemsPerPage)
}
